import appErrors from './appErrors';
import { combineReducers } from 'redux';
import consents from './consents';
import crtNotifications from './notifications';
import donationHistory from './donationHistory';
import donationSummary from './donationSummary';
import { features } from '../constants';
import findAddresses from './findAddresses';
import fitness from './fitness';
import localeData from './localeData';
import loginStatus from './loginStatus';
import paymentMethods from './paymentMethods';
import recurringPayments from './recurringPayments';
import directDebits from './directDebit';
import user from './user';
import userAddress from './userAddress';
import userNotifications from './userNotifications';
import verifyPhone from './verifyPhone';

const notifications = features.preferencesService
  ? userNotifications
  : crtNotifications;

export default combineReducers({
  loginStatus,
  user,
  userAddress,
  findAddresses,
  notifications,
  paymentMethods,
  localeData,
  verifyPhone,
  recurringPayments,
  directDebits,
  appErrors,
  donationHistory,
  donationSummary,
  consents,
  fitness,
});
